import { Observable } from "rxjs";

export type EventName = keyof GlobalEventHandlersEventMap;
export class DomEventService {
    public static GetBodyEvents<T extends EventName>(eventName: T): Observable<GlobalEventHandlersEventMap[T]>{
        // Stub for Application 
        return {} as Observable<GlobalEventHandlersEventMap[T]>;
    }
}